export default "assets/default.dd465767ac663475.png"